var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13C23.1274 13 28.5 10.7614 28.5 8C28.5 5.23858 23.1274 3 16.5 3C9.87258 3 4.5 5.23858 4.5 8C4.5 10.7614 9.87258 13 16.5 13Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 13.375C28.5 16.1363 23.125 18.375 16.5 18.375C9.875 18.375 4.5 16.1363 4.5 13.375M28.5 18.75C28.5 21.5113 23.125 23.75 16.5 23.75C9.875 23.75 4.5 21.5113 4.5 18.75",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.95251V24.0475C4.5 26.7825 9.875 29 16.5 29C23.125 29 28.5 26.7825 28.5 24.0475V7.95251",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendIcon);
export default __webpack_public_path__ + "static/media/backend-icon.a63a1958a3c4220830098e62f2d6abf0.svg";
export { ForwardRef as ReactComponent };